export const SET_RESOURCE = 'SET_RESOURCE';

export function setResource(data) {
    return { type: SET_RESOURCE, data };
}